import { render } from "./infoEndereco.vue?vue&type=template&id=1525dbde"
import script from "./infoEndereco.vue?vue&type=script&lang=js"
export * from "./infoEndereco.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__